module.exports = __webpack_public_path__ + "static/media/visitas_orientadas_mobile.7ce1eabb.webp";